/** Глубокая чистка аналитики перед отправкой на бэк (граница формы и апи, ZEN #9):
 *  - удаляет NaN-значения (оборонное, форма их не создаёт), '' и undefined;
 *  - массив, ставший пустым, и объект без оставшихся ключей превращаются в undefined
 *    (axios-клиент выбросит такие ключи из тела): бэк требует обязательные поля внутри
 *    секции только если секция передана (напр. liveness.livenesses_weights ≥ 2 при
 *    наличии liveness) — пустые секции просто не отправляются. */
import { stripUndefined } from '@vlabs/monokit/shared/lib/utils';

export function stripEmpty(value: unknown): unknown {
  if (Array.isArray(value)) {
    const stripped = value
      .filter((item) => (typeof item !== 'number' || !Number.isNaN(item)) && item !== '')
      .map(stripEmpty)
      .filter((item) => item !== undefined);

    return stripped.length > 0 ? stripped : undefined;
  }

  if (typeof value === 'object' && value !== null) {
    const stripped = Object.fromEntries(
      Object.entries(value as Record<string, unknown>)
        .filter(([, item]) => (typeof item !== 'number' || !Number.isNaN(item)) && item !== '')
        .map(([key, item]) => [key, stripEmpty(item)]),
    );

    return stripUndefined(stripped);
  }

  return value;
}
